import { ChangeEvent, useState } from 'react'

import { onlyLettersString } from '../../helpers/inputValidation'
import toast from 'react-hot-toast'
import { capitalize, inputJson } from '../../helpers/eliminarEs'

import { ModalBtn } from '../modals/ModalBtn'
import { CounterInput } from '../pages/Inputs/CounterInput'
import { useAddNewItem } from '../../api/useEditItem'
import { DetailName } from '../../interfaces/interfaces'
import { DetailObject, InitialPallets } from '../../interfaces/intakes.reports'
import { ToggleBtn } from '../ToggleBtn'
import { SelectDefect } from './SelectDefect'

interface Props {
    closeModal: () => void
    handleNewDefect: (label: string, name: string, isMajor: boolean) => void
    // existingDefects: string[]
}

export const ModalAddDefect = ({ closeModal, handleNewDefect: handleDefect }: Props) => {

    const [label, setLabel] = useState("")
    const [isMajor, setIsMajor] = useState<boolean>(false)

    const saveItem = async () => {

        // if (existingDefects.includes(inputJson(label))) return toast.error("This input already exist")
        if (!onlyLettersString(label)) return toast.error("Label name must be only letters")

        handleDefect(label, inputJson(label), isMajor)
    };

    const handleName = (e: ChangeEvent<HTMLInputElement>) => {
        setLabel(capitalize(e.target.value))
    };

    return (
        <div className="modal">

            <div className="modal__card">
                {
                    <div className="modal__content">

                        <label className='bold'>Name</label>
                        <input
                            className="mb-2"
                            type="text"
                            value={label}
                            maxLength={20}
                            onChange={handleName}
                        />



                            <>
                                {/* <CounterInput
                                    handleInput={handleCounter}
                                    value={newCounter}
                                    max={100}
                                    className='mb-2'
                                /> */}
                                <div className='flex-end flex-center'>
                                    <p className={`font-small ${isMajor ? "text-major" : "text-minor"} mr-05`}>{isMajor ? "Major defect" : "Minor defect"}</p>
                                    <ToggleBtn state={isMajor} action={() => setIsMajor(item => !item)} isDefect />
                                </div>
                            </>
                        

                        <ModalBtn
                            closeModal={closeModal}
                            action={saveItem}
                            actionTitle='Add'
                            disabled={!label}
                        />

                    </div>
                }

            </div>



        </div >
    )
}